import { render } from "./request-lists.vue?vue&type=template&id=4b0c37e0&scoped=true"
import script from "./request-lists.vue?vue&type=script&lang=js"
export * from "./request-lists.vue?vue&type=script&lang=js"

import "./request-lists.vue?vue&type=style&index=0&id=4b0c37e0&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0c37e0"]])

export default __exports__